import React, { useRef } from "react";
import "./css/SigninOTPView.css";
import whiteArrow from "../../../assets/images/white-arrow.svg";
import { CircularProgress } from "@mui/material";

interface SigninOTPViewProps {
  userEmail: string;
  length?: number;
  onChange: (otp: string) => void;
  onClickVerify: () => void;
  onClickChangeEmail: () => void;
  isLoading: boolean;
  resendTimer: number;
  onClickResendOTP: () => void;
}

const SigninOTPView: React.FC<SigninOTPViewProps> = ({
  userEmail,
  length = 6,
  onChange,
  onClickVerify,
  onClickChangeEmail,
  isLoading,
  resendTimer,
  onClickResendOTP,
}) => {
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);

  const isOtpComplete = (): boolean => {
    return inputRefs.current.every(
      (input) => input && input.value.length === 1
    );
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    i: number
  ): void => {
    const value = e.target.value.slice(-1);
    e.target.value = value;
    if (value && i < length - 1) {
      inputRefs.current[i + 1]?.focus();
    }
    triggerOtpChange();
  };

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    i: number
  ): void => {
    if (e.key === "Backspace" && !e.currentTarget.value && i > 0) {
      inputRefs.current[i - 1]?.focus();
    }
  };

  const triggerOtpChange = (): void => {
    const otp = inputRefs.current.map((input) => input?.value || "").join("");
    onChange(otp);
  };

  const formatTime = (seconds: number): string => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  };

  const handleResendClick = () => {
    inputRefs.current.forEach((input) => {
      if (input) input.value = "";
    });
    onChange("");
    onClickResendOTP();
  };

  return (
    <div className="signin-otp-view-container">
      <p>Email</p>
      <div className="signin-otp-view-email-field">{userEmail}</div>
      <div className="signin-otp-change-email" onClick={onClickChangeEmail}>
        Change Email
      </div>
      <p>Email OTP</p>
      <div className="signin-otp-input-group">
        {Array.from({ length }).map((_, i) => (
          <input
            key={i}
            type="tel"
            inputMode="numeric"
            maxLength={1}
            className="otp-input"
            ref={(el) => {
              inputRefs.current[i] = el;
            }}
            onChange={(e) => handleChange(e, i)}
            onKeyDown={(e) => handleKeyDown(e, i)}
          />
        ))}
      </div>
      <div className="signin-otp-resend">
        {resendTimer > 0 ? (
          <span>Resend OTP in {formatTime(resendTimer)}</span>
        ) : (
          <span onClick={handleResendClick}>Resend OTP</span>
        )}
      </div>
      <div
        className="signin-otp-view-button-container"
        onClick={isOtpComplete() ? onClickVerify : undefined}
        style={{
          opacity: isOtpComplete() ? 1 : 0.5,
        }}
      >
        {isLoading ? (
          <CircularProgress size={30} color="inherit" />
        ) : (
          <>
            VERIFY
            <img
              src={whiteArrow}
              className="signin-otp-view-arrow-icon"
              alt="logo"
            />
          </>
        )}
      </div>
    </div>
  );
};

export default SigninOTPView;
